import React from 'react';

/**
 * Components
 */
import ApplicationActions from 'Components/ApplicationActions';
import BasicInfo from '../Details/BasicInfo';
import BoatInfo from '../Details/BoatInfo';
import GeneralInfo from '../Details/GeneralInfo';
import BoatSystems from '../Details/BoatSystems';
import CubicCapacity from '../Details/CubicCapacity';
import BoatWeight from '../Details/BoatWeight';
import PersonWeightCapacity from '../Details/PersonWeightCapacity';
import PowerCapacity from '../Details/PowerCapacity';
import BoatFlotation from '../Details/BoatFloatation';
import Header from '../Details/Header';
import AdditionalDocuments from '../Details/AdditionalFiles';

export default class PersonPowerCapacity extends React.Component {
  handleMoveToArbitraryStep = stepId => {
    const {goToStep} = this.props;
    goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
  };

  handleSubmitButtonClick = () => {
    const {handleBoatSubmit} = this.props;
    handleBoatSubmit();
  };

  render() {
    const {user, goToStep, boat, getNavBar, handleDeleteDraft, actionsList} = this.props;

    return (
      <React.Fragment>
        <Header
          actionsList={actionsList}
          isFinalReview
          performAction={() => () => {
            handleDeleteDraft();
          }}
          user={user}
          boat={boat}
        />
        {getNavBar && getNavBar(() => {}, this.handleMoveToArbitraryStep)}
        <BasicInfo boat={boat} />
        <BoatInfo boatSpecifications={boat.boatSpecifications} isFinalReview goToStep={goToStep} />
        <GeneralInfo
          boatSpecifications={boat.boatSpecifications}
          dualSteering={boat.dualSteering}
          isFinalReview
          goToStep={goToStep}
        />
        <BoatSystems boatSystems={boat.boatSystems} isFinalReview goToStep={goToStep} />
        <CubicCapacity cubicCapacity={boat.cubicCapacity} boatType={boat.boatType} isFinalReview goToStep={goToStep} />
        <BoatWeight
          plateType={boat.plateType}
          personPowerCapacity={boat.personPowerCapacity}
          isFinalReview
          goToStep={goToStep}
        />
        <PersonWeightCapacity personPowerCapacity={boat.personPowerCapacity} goToStep={goToStep} isFinalReview />
        <PowerCapacity powerCapacity={boat.powerCapacity} isFinalReview goToStep={goToStep} />
        <BoatFlotation
          floatationCapacity={boat.floatationCapacity}
          applicationId={boat.id}
          isFinalReview
          goToStep={goToStep}
        />
        <AdditionalDocuments
          additionalFiles={boat.additionalFiles}
          applicationId={boat.id}
          goToStep={goToStep}
          isFinalReview
        />

        <ApplicationActions
          saveButtonLabel='Submit'
          saveButtonAction={this.handleSubmitButtonClick}
          backButtonLabel='Prev. Step'
          backButtonAction={this.handleMoveToArbitraryStep}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/FinalReview.jsx